import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { ControlFactory } from "appworks/ui/factories/control-factory";
import { GamevyAutoSpinStopControl } from "../controls/gamevy-auto-spin-stop-control";

export class GamevyAutoSpinStopControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        return layer.getFlexiButton("gamevy_auto_spin_stop") != null;
    }

    public build(layer: Layers): AbstractControl[] {
        const button = layer.getFlexiButton("gamevy_auto_spin_stop");
        return [new GamevyAutoSpinStopControl(button)];
    }
}
